export const crossFarmUuid = 'dashboard';

// Backend/user-settings sentinel for "no farm selected".
export const unknownFarmUuid = 'UNKNOWN';

export const isResolvedFarmUuid = (farmUuid?: string): farmUuid is string =>
  Boolean(farmUuid && farmUuid !== unknownFarmUuid);
